import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import { useGlobalStore } from '@/stores/globalStore'
import { useTree } from '@/api/hooks/useTree'
import { IconChevronDown } from './icons'
import { BackButton } from '@/features/floor-selector/BackButton'

const FloorBadge = () => {
  const activeLayer = useGlobalStore(state => state.activeLayer)
  const setActiveLayer = useGlobalStore(state => state.setActiveLayer)
  const { layers } = useTree()
  const [open, setOpen] = useState(false)

  const floors = useMemo(() => {
    if (!layers?.nodes) return []
    return layers.nodes.map(layer => ({
      id: layer.id,
      name: layer.name,
      isActive: layer.id === activeLayer
    }))
  }, [layers?.nodes, activeLayer])

  const currentFloor = floors.find(f => f.isActive)?.name || 'Выбрать этаж'

  return (
    <Wrapper>
      <BackButtonWrapper>
        <BackButton />
      </BackButtonWrapper>
      <Container className={open ? 'opened' : ''}>
        <DropDownHeader onClick={() => setOpen(!open)}>
          <span>{currentFloor}</span>
          <ExpandButton open={open}>
            <IconChevronDown />       
          </ExpandButton>
        </DropDownHeader>

        {open && floors.length > 0 && (
          <List>
            {floors.map(floor => (
              <ListItem
                key={floor.id}
                className={floor.isActive ? 'active' : ''}
                onClick={() => {
                  setActiveLayer(floor.id)
                  setOpen(false)
                }}
              >
                {floor.name}
              </ListItem>
            ))}
          </List>
        )}
      </Container>
    </Wrapper>
  )
}

export default FloorBadge

const Wrapper = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: 95px;
  z-index: 200;
  width: 256px;
`
const BackButtonWrapper = styled.div`
  position: absolute;
  left: -120px;
  top: 0;
  display: flex;
  align-items: center;
`

const Container = styled.div`
  width: 100%;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  background: #4d5759;
  transition: all 0.2s ease;

  &.opened {
    background: #fff;
    box-shadow: 7px 5px 20px 0px rgba(95, 119, 153, 0.2);
  }
`

const DropDownHeader = styled.div`
  padding: 8px 24px;
  background: #ffffffff;
  border-radius: 8px;
  border: 1px solid #2F323C;
  box-sizing: border-box;
  font-size: 16px;
  color: #2F323C;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  

  ${Container}.opened & {
    background: #fff;
    color: #000;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);
  }
`

const ExpandButton = styled.div<{ open?: boolean }>`
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
  transform: rotate(${props => (props.open ? '180deg' : '0deg')});

  svg {
    width: 40px;
    height: 40px;
    color: currentColor;
  }
`

const List = styled.ul`
  background: #ffffff;
  box-sizing: border-box;
  color: #2F323C;
  font-size: 16px;
  overflow-y: auto;
  max-height: 300px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
`

const ListItem = styled.li`
  list-style: none;
  cursor: pointer;
  text-align: center;
  line-height: 16px;
  min-height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 8px;
  transition: background 0.2s, color 0.2s;

  &:nth-of-type(even) {
    background: var(--bg-disabled, #F2F3F4);
  }

  &:hover {
    background: var(--bg-dark, #C12423);
    color: var(--text-on-color, #000);
  }

  &.active {
    background: #b2a8a6;
    color: #fff;
  }
`
